var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerFlashLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31859 4.97211C6.60166 3.94576 8.22916 3.33203 10 3.33203C11.7708 3.33203 13.3983 3.94576 14.6814 4.97211L15.8926 3.76096L17.0711 4.93947L15.8599 6.15062C16.8863 7.43369 17.5 9.0612 17.5 10.832C17.5 14.9742 14.1422 18.332 10 18.332C5.85787 18.332 2.5 14.9742 2.5 10.832C2.5 9.0612 3.11373 7.43369 4.14008 6.15062L2.92893 4.93947L4.10744 3.76096L5.31859 4.97211ZM10 16.6654C13.2217 16.6654 15.8333 14.0537 15.8333 10.832C15.8333 7.61037 13.2217 4.9987 10 4.9987C6.77834 4.9987 4.16667 7.61037 4.16667 10.832C4.16667 14.0537 6.77834 16.6654 10 16.6654ZM10.8333 9.9987H13.3333L9.16667 15.4154V11.6654H6.66667L10.8333 6.2447V9.9987ZM6.66667 0.832031H13.3333V2.4987H6.66667V0.832031Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerFlashLine);
export default __webpack_public_path__ + "static/media/timer-flash-line.211dc36e4f4718919e821a2c2e07d195.svg";
export { ForwardRef as ReactComponent };